var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-col",
        { class: "stock-check", attrs: { xs: "12" } },
        [
          _c("w-checkbox", {
            attrs: { label: _vm.$ct("show-seperate-stock-info"), space: "" },
            model: {
              value: _vm.settings.ShowSeperateStockInfo,
              callback: function ($$v) {
                _vm.$set(_vm.settings, "ShowSeperateStockInfo", $$v)
              },
              expression: "settings.ShowSeperateStockInfo",
            },
          }),
        ],
        1
      ),
      _c(
        "w-sortable",
        {
          attrs: {
            tag: "w-list",
            "target-class": "handle",
            items: _vm.settings.SaleEditRowExtraInfoFields,
          },
        },
        [
          _vm._l(_vm.items, function (item, i) {
            return _c(
              "w-list-item",
              { key: item.getId(), attrs: { "show-handle": "" } },
              [
                _c("w-list-item-text", [
                  _vm._v(_vm._s(item.getDisplayName(_vm.model))),
                ]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("edit-row"),
                            expression: "$ct('edit-row')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editItem(item)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("delete-row"),
                            expression: "$ct('delete-row')",
                          },
                        ],
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            return _vm.removeItem(i)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.addItem()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [
                _vm._v(
                  _vm._s(
                    _vm.$ct("add-sale-edit-row-extra-info-fields-settings")
                  )
                ),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditRow != null } },
        [
          _vm.toEditRow
            ? _c("app-sale-edit-row-extra-info-field-settings-edit", {
                attrs: { value: _vm.toEditRow, "is-new": _vm.editRowIsNewRow },
                on: {
                  close: function ($event) {
                    _vm.toEditRow = null
                  },
                  input: function ($event) {
                    return _vm.onEditRowSave($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }